import { useState } from 'react';

import { Button, Drawer, Radio } from '@iwoca/orion';

import { buildSortGroups } from './buildSortOptions';
import { OrderingParam, TabConfig } from '../../CustomersV2.types';

export const SortDrawer = ({
  config,
  activeSort,
  isOpen,
  onClose,
  onSort,
}: {
  config: TabConfig;
  /** Resolved ordering currently applied — seeds the staged selection. */
  activeSort: OrderingParam;
  isOpen: boolean;
  onClose: () => void;
  onSort: (value: OrderingParam) => void;
}) => {
  const groups = buildSortGroups(config);

  // Selection is staged locally and only committed on Apply, so Close/overlay
  // dismiss discards it. Re-seed from the active sort each time the drawer opens
  // by tracking the last-seen open state and resetting during render (React's
  // "adjust state on prop change" pattern — no effect needed).
  const [staged, setStaged] = useState<OrderingParam>(activeSort);
  const [wasOpen, setWasOpen] = useState(isOpen);
  if (isOpen !== wasOpen) {
    setWasOpen(isOpen);
    if (isOpen) setStaged(activeSort);
  }

  const apply = () => {
    onSort(staged);
    onClose();
  };

  return (
    <Drawer isOpen={isOpen} onClose={onClose} title="Sort">
      <div className="flex h-full flex-col">
        <div className="flex flex-1 flex-col gap-l overflow-y-auto px-l pt-l">
          {groups.map((group) => (
            <fieldset key={group.heading} className="border-none p-0">
              <legend className="mb-m text-m font-med text-primary-10">
                {group.heading}
              </legend>
              <div className="flex flex-col gap-m border-b border-secondary-90 pb-l">
                {group.options.map((option) => (
                  <Radio
                    key={option.value}
                    name="customers-sort"
                    label={option.label}
                    value={option.value}
                    checked={staged === option.value}
                    onChange={() => setStaged(option.value)}
                  />
                ))}
              </div>
            </fieldset>
          ))}
        </div>

        <div className="flex gap-m p-l">
          <Button
            variant="tertiary"
            className="flex-1"
            onClick={() => setStaged(activeSort)}
          >
            Reset
          </Button>
          <Button className="flex-1" onClick={apply}>
            Apply
          </Button>
        </div>
      </div>
    </Drawer>
  );
};
